
/**
 * Claim Identifiers
 */
export class MojoStandardClaimNames {
  static readonly dbIdentity: string = 'db_identity';
  static readonly pmaUserDetailsId: string = 'PmaUserDetailsId';
  static readonly pmaPermission: string = 'PmaPermission';
  static readonly email: string = 'email';
  static readonly databaseDisplayName: string = 'DatabaseDisplayName';
  static readonly authenticatedViaDesktopApp: string = 'AuthenticatedViaDesktopApp';
  static readonly DaysLeftBeforePasswordExpires = 'daysLeftBeforeExpireWarning';
  static readonly previousLoginTime = 'PreviousLoginTime';
}

/**
 * Api Names. 
 */
export class MojoApiNames {
    static readonly mojoClientInvestorsApi: string = 'mojo_clients_investors_api';
    static readonly mojoIdentityAdministrationApi: string = 'mojo_identity_administration_api';
    static readonly mojoOnlineFormsApi: string = 'mojo_online_forms_api';
}

/**
 * Mojo specific scope names
 */
export class MojoStandardScopes {
    static readonly dbIdentity: string = 'db_identity';
    static readonly mciUserIdentity: string = "mci_user_identity";
    static readonly mojoClientInvestorsApi = MojoApiNames.mojoClientInvestorsApi;
    static readonly mojoIdentityAdministrationApi = MojoApiNames.mojoIdentityAdministrationApi;
    static readonly mojoOnlineFormsApi = MojoApiNames.mojoOnlineFormsApi;
}

/**
 * Open Id Standard Scopes
 */
export class OpenIdStandardScopes {
    static readonly openId: string = 'openid';
    static readonly profile: string = 'profile';
    static readonly email: string = 'email';
    static readonly address: string = 'address';
    static readonly phone: string = 'phone';
    static readonly offlineAccess: string = 'offline_access';
}

export class ClientIdentifiers {
    static readonly mojoPlatform: string = '2D1EF6ADA8CC3D21.MojoPlatform';
}

export class ReponseTypes {
  static readonly IdToken: string = "id_token";
  static readonly Token: string = "token";
  static readonly IdTokenAndToken: string = "id_token token";
  static readonly Code: string = "code";
  static readonly CodeAndIdToken: string = "code id_token";
  static readonly CodeAndIdTokenAndToken: string = "code id_token token";
}
